import {eggs} from "./eggs";
import {initInlineAnswerEditor} from './inline_answer_editor.js';

// Nothing to see here, just some regular old javascript.

export function initVanilla() {
    setupJSVars();
    cleanPHPVars();
    removeOldFormData();
    initInlineAnswerEditor();
}

function setupJSVars() {
    // Init JSVars
    let isTouch = window.ontouchstart ||
        navigator.maxTouchPoints > 0 ||
        navigator.MaxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0;

    if (isTouch) {
        $('body').addClass('is-touch-enabled');
    } else {
        $('body').addClass('not-touch-enabled');
    }

    if (!window.JSVars) {
        window.JSVars = {};
    }

    window.JSVars.isTouch = isTouch;

    eggs();
}

function cleanPHPVars() {
    if (window.PHPVars) {
        if (Array.isArray(window.PHPVars.inputs) && window.PHPVars.inputs.length == 0) {
            window.PHPVars.inputs = {}
        }
        if (Array.isArray(window.PHPVars.validation) && window.PHPVars.validation.length == 0) {
            window.PHPVars.validation = {}
        }
    }
}

function removeOldFormData() {
    let rawCookieValue;
    try {
        rawCookieValue = document.cookie.match(/delete-local-form-data=[^;]*/);
    } catch (e) {
        // document.cookie throws SecurityError in sandboxed/about:blank contexts
        return;
    }
    if (rawCookieValue === null) {
        return;
    }

    let formDataKeys = decodeURI(rawCookieValue[0].split('=')[1]).split('|');
    try {
        for (let key of formDataKeys) {
            localStorage.removeItem('formData-' + key);
        }
    } catch (e) {
        // localStorage unavailable — private browsing, iframe restrictions, etc.
    }
    // Remove the cookie
    try {
        document.cookie = 'delete-local-form-data=;expires=' + new Date(0).toUTCString() + ';path=/;'
    } catch (e) {
        // Cookie write blocked in sandboxed/headless context
    }
}
